/**
 * SkyVision LINEAR WALK-ON — begehbares modulares Lichtband.
 * Preis je Modul über die WALKON-Selbstkostenformel, Module in Reihe.
 */

import { calculateWalkOnPrice, WalkOnGlassType } from './priceConfigWalkOn';

export const LINEAR_WALKON_MODULE = {
  width: 1000,
  length: 1000,
  height: 210,
  maxArea: 4,
};

export function linearWalkOnModuleCount(width: number, length: number): number {
  const moduleWidth = Math.max(1, width || LINEAR_WALKON_MODULE.width);
  return Math.max(1, Math.round((length || moduleWidth) / moduleWidth));
}

export function calculateLinearWalkOnPrice(
  width: number,
  length: number,
  glassType: WalkOnGlassType | string = 'double',
): number {
  const count = linearWalkOnModuleCount(width, length);
  const moduleLength = (length || LINEAR_WALKON_MODULE.length) / count;
  return (
    calculateWalkOnPrice(
      width || LINEAR_WALKON_MODULE.width,
      moduleLength || LINEAR_WALKON_MODULE.length,
      glassType,
    ).totalPrice * count
  );
}

export function getLinearWalkOnStartingPrice(): number {
  return calculateWalkOnPrice(
    LINEAR_WALKON_MODULE.width,
    LINEAR_WALKON_MODULE.length,
    'double',
  ).totalPrice;
}
